import React from "react";
import "./ImageUpload.scss";

function ImageUpload({onImageChange}) {
    const [image, setImage] = React.useState(null);
    const fileInputRef = React.useRef(null);

    function handleImageChange(e) {
        const file = e.target.files[0];

        if (file && file.size > 3 * 1024 * 1024) {
            return;
        }

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage(reader.result);
                onImageChange(reader.result);
            };
            reader.readAsDataURL(file);
        }
    }

    const handleEditClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    return (
        <div className="image-uploader">
            {image ? (
                <img
                    src={image}
                    alt="Uploaded Preview"
                    className="image-uploader__preview"
                />
            ) : (
                <div className="image-uploader__placeholder">
                    Upload Image
                </div>
            )}

            <input
                ref={fileInputRef}
                id="image-uploader-input"
                type="file"
                accept="image/*"
                className="image-uploader__input"
                onChange={handleImageChange}
            />

            <button
                type="button"
                className="image-uploader__edit-btn"
                onClick={handleEditClick}
                title="Edit Image"
            >
                ✎
            </button>
        </div>
    );
}

export {ImageUpload};
